// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"f2f435db","425":"e3a81a73","510":"832576b5","532":"414d80e7","633":"edcfa801","634":"424fb965","922":"b4620766","937":"15db6b7e","972":"65cb3ce7"}[chunkId] + ".chunk.js";
};